import './FinanceExample.scss';

import React from 'react';
import useAprExamples from '../../../hooks/useAprExamples';
import { useMediaQuery } from 'react-responsive';
import { Switch24BannerTerms } from '../../Banner/Switch24BannerTerms';
import { useTheme } from '../../../hooks/useTheme';
import TRANSLATIONS from '../../../translations/translations@default.json';
import PatternLeft from './PatternLeft';
import PatternRight from './PatternRight';

export const FinanceExample = () => {
	const {
		showSwitch24Example,
		financeRepExampleText,
		aprPurchaseRate,
		aprRepresentative,
	} = useAprExamples();

	const theme = useTheme('financeFooter');

	const isBelow543 = useMediaQuery({
		maxWidth: 543,
	});

	const isBelow768 = useMediaQuery({
		maxWidth: 768,
	});

	let viewBox = '0 0 153.86 123';

	if (isBelow543) {
		viewBox = '70 0 20 123';
	} else if (isBelow768) {
		viewBox = '0 0 133.86 123';
	}

	return (
		<div className="w-full max-w-screen-md md:mt-8">
			<div className={`flex md:rounded-md overflow-hidden ${theme.background}`}>
				<PatternLeft viewBox={viewBox} fill={theme.fill} />
				<div
					className="flex flex-col flex-grow items-center justify-center sm:px-4 py-4 sm:py-0"
					data-testid="financeBanner"
					style={{ minHeight: '123px' }}>
					<p className={`text-body-xs mb-2 ${theme.text}`}>
						{financeRepExampleText}
					</p>

					<div className="flex items-center justify-between">
						<div className="px-2 sm:px-6">
							<span
								className={`text-title-sm whitespace-no-wrap ${theme.title}`}>
								{aprRepresentative}% APR
							</span>
							<p className={`text-body-xs whitespace-no-wrap ${theme.text}`}>
								Representative
								<br /> (variable)
							</p>
						</div>
						<div className="px-2 sm:px-6">
							<span
								className={`text-title-sm whitespace-no-wrap ${theme.title}`}>
								{aprPurchaseRate}% PA
							</span>
							<p className={`text-body-xs whitespace-no-wrap ${theme.text}`}>
								Purchase rate
								<br /> (variable)
							</p>
						</div>
						<div className="px-2 sm:px-6">
							<span
								className={`text-title-sm whitespace-no-wrap ${theme.title}`}>
								{
									TRANSLATIONS.listerFooter.financeExample
										.assumedCreditLimitAmountText
								}
							</span>
							<p className={`text-body-xs whitespace-no-wrap ${theme.text}`}>
								Assumed
								<br /> credit limit
							</p>
						</div>
					</div>
				</div>
				<PatternRight viewBox={viewBox} fill={theme.fill} />
			</div>

			<div className="text-sm mt-4 px-2">
				<p className="text-sm">
					{TRANSLATIONS.listerFooter.financeExample.creditText}
				</p>
				<div className="font-bold mt-2">
					{TRANSLATIONS.listerFooter.financeExample.creditTextBold}
				</div>
				<div className="mt-2">
					{showSwitch24Example && <Switch24BannerTerms UseLineBreak={true} />}
				</div>
				<div className="mt-2">
					<p>{TRANSLATIONS.listerFooter.financeExample.creditUpfrontText}</p>
				</div>
			</div>
		</div>
	);
};

export default FinanceExample;
